import React from 'react';
import NavigationHeader from 'components/ui/NavigationHeader';
import NotificationToast from 'components/ui/NotificationToast';
import { useToast } from 'hooks/useToast';

export default function AppLayout({ children }) {
  const { toasts, dismissToast } = useToast();

  return (
    <div className="min-h-screen bg-background">
      <NavigationHeader />
      {/* El encabezado es sticky (AppHeader): ya no hace falta reservar sus 64 px.
          Va a todo el ancho (shared 859cb56): las pantallas usan su mismo relleno
          lateral (px-[16px] sm:px-[24px] lg:px-[32px]) y quedan alineadas con el
          logo; el formulario de registro (max-w-lg) sigue centrado. */}
      <main style={{ minHeight: 'calc(100vh - 94px)', paddingTop: 30 }}>
        {children}
      </main>
      <NotificationToast toasts={toasts} onDismiss={dismissToast} />
    </div>
  );
}